import { AfterContentInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

enum SearchAction {
  Prev = 0,
  Next = 1,
  Find = 2,
  Replace = 3,
  ReplaceAll = 4
}

@Component({
  selector: 'app-find-and-replace-modal',
  templateUrl: './find-and-replace-modal.component.html',
  styleUrls: ['./find-and-replace-modal.component.scss'],
  standalone: false
})
export class FindAndReplaceModalComponent implements AfterContentInit {
  @Input() editor!: any;
  @Input() textToSearch?: string;

  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;
  @ViewChild('replaceInput') replaceInput: ElementRef<HTMLInputElement>;

  readonly SearchAction = SearchAction;

  constructor(private modal: NgbActiveModal) {}

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.clear();

      if (this.textToSearch.length > 0) {
        this.search();
      }

      this.searchInput.nativeElement.focus();
    });
  }

  search() {
    const searchText = this.searchInput.nativeElement.value;
    this.editor.commands.setSearchTerm(searchText);
    this.goToSelection();
  }

  toggleCaseSensitive(setFalse: boolean = false) {
    this.editor.commands.setCaseSensitive(setFalse ? false : !this.editor.storage.findAndReplace.caseSensitive);
    this.goToSelection();
  }

  clear = () => {
    this.editor.commands.setSearchTerm('');
    this.editor.commands.setReplaceTerm('');

    this.editor.commands.resetIndex();
    this.toggleCaseSensitive(true);
  };

  replace() {
    const replaceText = this.replaceInput.nativeElement.value;
    this.editor.commands.setReplaceTerm(replaceText);
    this.editor.commands.replace();

    setTimeout(() => this.searchInput.nativeElement.focus());
  }

  replaceAll() {
    const replaceText = this.replaceInput.nativeElement.value;
    this.editor.commands.setReplaceTerm(replaceText);
    this.editor.commands.replaceAll();

    setTimeout(() => this.searchInput.nativeElement.focus());
  }

  nextOccurance() {
    this.editor.commands.nextSearchResult();
    this.goToSelection();
  }

  prevOccurance() {
    this.editor.commands.previousSearchResult();
    this.goToSelection();
  }

  goToSelection() {
    const node = document.querySelector('.search-result--current') as HTMLElement;
    if (!node) return;

    node.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  keyPressedHandler(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.search();
    }
  }

  handleKeydown(e: KeyboardEvent, action: SearchAction) {
    if (e.key == 'Enter' || e.key == ' ') {
      e.preventDefault();

      const actions = {
        [SearchAction.Prev]: this.prevOccurance,
        [SearchAction.Next]: this.nextOccurance,
        [SearchAction.Find]: this.search,
        [SearchAction.Replace]: this.replace,
        [SearchAction.ReplaceAll]: this.replaceAll
      };
      actions[action]();
    }
  }

  closeModal() {
    this.clear();
    this.modal.dismiss();
  }
}
